var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVanishingStripes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 2000,
    height: 2000,
    viewBox: "0 0 800 800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#000022",
    width: 800,
    height: 800
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#026",
    strokeWidth: 17
  }, /*#__PURE__*/React.createElement("line", {
    x1: -8,
    y1: -8,
    x2: 808,
    y2: 808
  }), /*#__PURE__*/React.createElement("line", {
    x1: -8,
    y1: 792,
    x2: 808,
    y2: 1608
  }), /*#__PURE__*/React.createElement("line", {
    x1: -8,
    y1: -808,
    x2: 808,
    y2: 8
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#002163",
    strokeWidth: 16
  }, /*#__PURE__*/React.createElement("line", {
    x1: -8,
    y1: 767,
    x2: 808,
    y2: 1583
  }), /*#__PURE__*/React.createElement("line", {
    x1: -8,
    y1: 17,
    x2: 808,
    y2: 833
  }), /*#__PURE__*/React.createElement("line", {
    x1: -8,
    y1: -33,
    x2: 808,
    y2: 783
  }), /*#__PURE__*/React.createElement("line", {
    x1: -8,
    y1: -783,
    x2: 808,
    y2: 33
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#002060",
    strokeWidth: 15
  }, /*#__PURE__*/React.createElement("line", {
    x1: -8,
    y1: 742,
    x2: 808,
    y2: 1558
  }), /*#__PURE__*/React.createElement("line", {
    x1: -8,
    y1: 42,
    x2: 808,
    y2: 858
  }), /*#__PURE__*/React.createElement("line", {
    x1: -8,
    y1: -58,
    x2: 808,
    y2: 758
  }), /*#__PURE__*/React.createElement("line", {
    x1: -8,
    y1: -758,
    x2: 808,
    y2: 58
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#001f5c",
    strokeWidth: 14
  }, /*#__PURE__*/React.createElement("line", {
    x1: -8,
    y1: 67,
    x2: 808,
    y2: 883
  }), /*#__PURE__*/React.createElement("line", {
    x1: -8,
    y1: 717,
    x2: 808,
    y2: 1533
  }), /*#__PURE__*/React.createElement("line", {
    x1: -8,
    y1: -733,
    x2: 808,
    y2: 83
  }), /*#__PURE__*/React.createElement("line", {
    x1: -8,
    y1: -83,
    x2: 808,
    y2: 733
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#001e59",
    strokeWidth: 13
  }, /*#__PURE__*/React.createElement("line", {
    x1: -8,
    y1: 92,
    x2: 808,
    y2: 908
  }), /*#__PURE__*/React.createElement("line", {
    x1: -8,
    y1: 692,
    x2: 808,
    y2: 1508
  }), /*#__PURE__*/React.createElement("line", {
    x1: -8,
    y1: -108,
    x2: 808,
    y2: 708
  }), /*#__PURE__*/React.createElement("line", {
    x1: -8,
    y1: -708,
    x2: 808,
    y2: 108
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#001d56",
    strokeWidth: 12
  }, /*#__PURE__*/React.createElement("line", {
    x1: -8,
    y1: 667,
    x2: 808,
    y2: 1483
  }), /*#__PURE__*/React.createElement("line", {
    x1: -8,
    y1: 117,
    x2: 808,
    y2: 933
  }), /*#__PURE__*/React.createElement("line", {
    x1: -8,
    y1: -133,
    x2: 808,
    y2: 683
  }), /*#__PURE__*/React.createElement("line", {
    x1: -8,
    y1: -683,
    x2: 808,
    y2: 133
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#001c53",
    strokeWidth: 11
  }, /*#__PURE__*/React.createElement("line", {
    x1: -8,
    y1: 642,
    x2: 808,
    y2: 1458
  }), /*#__PURE__*/React.createElement("line", {
    x1: -8,
    y1: 142,
    x2: 808,
    y2: 958
  }), /*#__PURE__*/React.createElement("line", {
    x1: -8,
    y1: -158,
    x2: 808,
    y2: 658
  }), /*#__PURE__*/React.createElement("line", {
    x1: -8,
    y1: -658,
    x2: 808,
    y2: 158
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#001b4f",
    strokeWidth: 10
  }, /*#__PURE__*/React.createElement("line", {
    x1: -8,
    y1: 167,
    x2: 808,
    y2: 983
  }), /*#__PURE__*/React.createElement("line", {
    x1: -8,
    y1: 617,
    x2: 808,
    y2: 1433
  }), /*#__PURE__*/React.createElement("line", {
    x1: -8,
    y1: -633,
    x2: 808,
    y2: 183
  }), /*#__PURE__*/React.createElement("line", {
    x1: -8,
    y1: -183,
    x2: 808,
    y2: 633
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#001a4c",
    strokeWidth: 9
  }, /*#__PURE__*/React.createElement("line", {
    x1: -8,
    y1: 592,
    x2: 808,
    y2: 1408
  }), /*#__PURE__*/React.createElement("line", {
    x1: -8,
    y1: 192,
    x2: 808,
    y2: 1008
  }), /*#__PURE__*/React.createElement("line", {
    x1: -8,
    y1: -608,
    x2: 808,
    y2: 208
  }), /*#__PURE__*/React.createElement("line", {
    x1: -8,
    y1: -208,
    x2: 808,
    y2: 608
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#001949",
    strokeWidth: 8
  }, /*#__PURE__*/React.createElement("line", {
    x1: -8,
    y1: 567,
    x2: 808,
    y2: 1383
  }), /*#__PURE__*/React.createElement("line", {
    x1: -8,
    y1: 217,
    x2: 808,
    y2: 1033
  }), /*#__PURE__*/React.createElement("line", {
    x1: -8,
    y1: -233,
    x2: 808,
    y2: 583
  }), /*#__PURE__*/React.createElement("line", {
    x1: -8,
    y1: -583,
    x2: 808,
    y2: 233
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#001846",
    strokeWidth: 7
  }, /*#__PURE__*/React.createElement("line", {
    x1: -8,
    y1: 242,
    x2: 808,
    y2: 1058
  }), /*#__PURE__*/React.createElement("line", {
    x1: -8,
    y1: 542,
    x2: 808,
    y2: 1358
  }), /*#__PURE__*/React.createElement("line", {
    x1: -8,
    y1: -558,
    x2: 808,
    y2: 258
  }), /*#__PURE__*/React.createElement("line", {
    x1: -8,
    y1: -258,
    x2: 808,
    y2: 558
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#001743",
    strokeWidth: 6
  }, /*#__PURE__*/React.createElement("line", {
    x1: -8,
    y1: 267,
    x2: 808,
    y2: 1083
  }), /*#__PURE__*/React.createElement("line", {
    x1: -8,
    y1: 517,
    x2: 808,
    y2: 1333
  }), /*#__PURE__*/React.createElement("line", {
    x1: -8,
    y1: -533,
    x2: 808,
    y2: 283
  }), /*#__PURE__*/React.createElement("line", {
    x1: -8,
    y1: -283,
    x2: 808,
    y2: 533
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#00163f",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("line", {
    x1: -8,
    y1: 292,
    x2: 808,
    y2: 1108
  }), /*#__PURE__*/React.createElement("line", {
    x1: -8,
    y1: 492,
    x2: 808,
    y2: 1308
  }), /*#__PURE__*/React.createElement("line", {
    x1: -8,
    y1: -308,
    x2: 808,
    y2: 508
  }), /*#__PURE__*/React.createElement("line", {
    x1: -8,
    y1: -508,
    x2: 808,
    y2: 308
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#00153c",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("line", {
    x1: -8,
    y1: 467,
    x2: 808,
    y2: 1283
  }), /*#__PURE__*/React.createElement("line", {
    x1: -8,
    y1: 317,
    x2: 808,
    y2: 1133
  }), /*#__PURE__*/React.createElement("line", {
    x1: -8,
    y1: -333,
    x2: 808,
    y2: 483
  }), /*#__PURE__*/React.createElement("line", {
    x1: -8,
    y1: -483,
    x2: 808,
    y2: 333
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#001439",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("line", {
    x1: -8,
    y1: 342,
    x2: 808,
    y2: 1158
  }), /*#__PURE__*/React.createElement("line", {
    x1: -8,
    y1: 442,
    x2: 808,
    y2: 1258
  }), /*#__PURE__*/React.createElement("line", {
    x1: -8,
    y1: -458,
    x2: 808,
    y2: 358
  }), /*#__PURE__*/React.createElement("line", {
    x1: -8,
    y1: -358,
    x2: 808,
    y2: 458
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#001336",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("line", {
    x1: -8,
    y1: 367,
    x2: 808,
    y2: 1183
  }), /*#__PURE__*/React.createElement("line", {
    x1: -8,
    y1: 417,
    x2: 808,
    y2: 1233
  }), /*#__PURE__*/React.createElement("line", {
    x1: -8,
    y1: -433,
    x2: 808,
    y2: 383
  }), /*#__PURE__*/React.createElement("line", {
    x1: -8,
    y1: -383,
    x2: 808,
    y2: 433
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#013",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("line", {
    x1: -8,
    y1: 392,
    x2: 808,
    y2: 1208
  }), /*#__PURE__*/React.createElement("line", {
    x1: -8,
    y1: -408,
    x2: 808,
    y2: 408
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVanishingStripes);
export default __webpack_public_path__ + "static/media/vanishing-stripes.dd3f3673d7a0c2391d566da5fe6a7b6b.svg";
export { ForwardRef as ReactComponent };